import { Post } from "domain/infra/data/api";
import CampanhaConstants from "../../infra/data/campanhaConstants";
import ValidationResult from "domain/types/global/validationResult";

export class AprovarPedidoService {
  constructor() {
  }
  async AprovarPedido(campanhaPedidoResgateId: number, statusAtual: number, usuarioAprovador: string, empresaId: string, status: number): Promise<ValidationResult | Error> {
    return await Post(CampanhaConstants.apiCampanha.CampanhasUsuario.aprovarResgate, { campanhaPedidoResgateId, statusAtual, usuarioAprovador, empresaId, status })
  }

  async ReprovarPedido(campanhaPedidoResgateId: number, motivo: string, usuario: string): Promise<ValidationResult | Error> {
    return await Post(CampanhaConstants.apiCampanha.CampanhasUsuario.reprovarResgate, { campanhaPedidoResgateId, motivo, usuario })
  }


}
